export function camelCaseToDashCase(str) {
	return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}

export function dashCaseToCamelCase(str) {
	return str.replace(/\W+(.)/g, (x, chr) => chr.toUpperCase());
}

export function capitalizeFirstLetter(str, isOtherToLowerCase) {
	if (isOtherToLowerCase) {
		return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
	} else {
		return str.charAt(0).toUpperCase() + str.slice(1);
	}
}
